import { styled } from '@mui/material/styles';

import { palette, lightGreyBoxShadow, rem, Theme } from '../../theme';

import { PromoTileVIColor } from './PromoTile.types';

export const promoTileColorsMap = {
    [PromoTileVIColor.Blue]: palette.primary.main,
    [PromoTileVIColor.Green]: palette.secondary.main,
    [PromoTileVIColor.DarkBlue]: palette.common.blue,
    [PromoTileVIColor.Ultimate]: palette.pino.ultimate,
    [PromoTileVIColor.Standard]: palette.pino.standard,
    [PromoTileVIColor.OffPeak]: palette.pino.offPeak,
};

export const StyledPromoTile = styled('div')`
    ${({
        theme,
        color,
        $isCarouselChild,
    }: {
        theme: Theme;
        color: string;
        $isCarouselChild: boolean;
    }) => `
    position: relative;
    height: ${$isCarouselChild ? '100%' : 'auto'};
    border-left: ${theme.tggSpacing(rem(0.8), 2)} solid ${color};
    border-radius: ${theme.tggSpacing(rem(0.8), 2)};
    box-shadow: ${lightGreyBoxShadow};

    hr {
        border-top: ${theme.tggSpacing(rem(0.2), 0.5)} solid ${color};
        margin-left: ${theme.tggSpacing(0, 0)};
        margin-right: ${theme.tggSpacing(0, 0)};
    }
    `}
`;

export const StyledContainer = styled('div')`
    ${({
        theme,
        $isSlim,
        $isCarouselChild,
    }: {
        theme: Theme;
        $isSlim?: boolean;
        $isCarouselChild?: boolean;
    }) => `
    display: flex;
    flex-direction: column;
    min-width: ${
        $isCarouselChild
            ? theme.tggSpacing(rem(27.2), 68)
            : theme.tggSpacing('auto', 'auto')
    };
    max-width: ${
        $isCarouselChild
            ? theme.tggSpacing(rem(55.2), 138)
            : theme.tggSpacing('auto', 'auto')
    };
    height: 100%;
    padding: ${
        $isSlim
            ? theme.tggSpacing([rem(1.8), rem(1.6), rem(1.6)], [4.5, 4, 4])
            : theme.tggSpacing([rem(1.8), rem(3)], [4.5, 7.5])
    }};

    hr {
        margin-top: ${
            $isSlim ? theme.tggSpacing(0, 0) : theme.tggSpacing(rem(0.8), 2)
        };
    }

    ${theme.breakpoints.up('desktop')} {
        min-width: ${
            $isCarouselChild
                ? theme.tggSpacing(rem(31.2), 78)
                : theme.tggSpacing('auto', 'auto')
        };
        padding: ${
            $isSlim
                ? theme.tggSpacing(
                      [rem(1.8), rem(1.6), rem(1.6)],
                      [7.2, 6.4, 6.4],
                  )
                : theme.tggSpacing([rem(1.8), rem(3)], [4.5, 7.5])
        };
    }
    `}
`;

export const StyledTitle = styled('div')`
    ${({ $isSlim, theme }) =>
        $isSlim ? theme.typography.text_16_bold : theme.typography.h4};
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: lowercase;

    span {
        ${({ $isSlim, theme }) => `
            padding-top: ${theme.tggSpacing(rem(1), 2.5)};
            padding-bottom: ${
                $isSlim
                    ? theme.tggSpacing(rem(0.5), 1.25)
                    : theme.tggSpacing(0, 0)
            };
        `}
    }
`;

export const StyledDetails = styled('div')`
    ${({ $isSlim, theme }) => `
    flex-grow: 1;
    margin-bottom: ${
        $isSlim ? theme.tggSpacing(0, 0) : theme.tggSpacing(rem(0.8), 2)
    };
    font-size: ${theme.tggSpacing(rem(1), 2.5)};
    line-height: ${theme.tggSpacing(rem(1.6), 4)};

    ${theme.breakpoints.up('desktop')} {
        font-size: ${theme.tggSpacing(rem(1.4), 3.5)};
        line-height: ${theme.tggSpacing(rem(1.8), 4.5)};
    }
    `}
`;

export const StyledPromoCodeContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_12_bold}
`;

export const StyledPromoCode = styled('div')`
    text-transform: none;
    white-space: nowrap;
`;
